import styled from "styled-components";
import Colors from "../../../constants/Colors";

export const Container = styled.div`
  display: flex;
  margin-top: 16px;

  @media screen and (max-width: 1224px) {
    padding-left: 2px;
    padding-right: 2px;
  }
`;
export const RowContainer = styled.div`
  display: flex;
  margin-top: 16px;
  flex-direction: row;
  margin-right: 8px;

  @media screen and (max-width: 780px) {
    flex-direction: column;
    margin-bottom: 8px;
    margin-right: 0px;
  }
`;

export const FooterButtonArea = styled.div`
  display: flex;
  margin-top: 40px;
  flex-direction: row;

  @media screen and (max-width: 1224px) {
    flex-direction: column;
    align-items: center;
    margin-bottom: 10%;
  }
`;

interface ButtonProps {
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
}

export const Button = styled.button<ButtonProps>`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 29px;
  gap: 10px;

  ${({ color }) =>
    color &&
    `
      color: ${color};
    `}
  ${({ borderColor = "#4d638d" }) =>
    borderColor && `border: 1px solid ${borderColor};`}
  background: ${({ backgroundColor = Colors.lightBlue }) => backgroundColor};

  border-radius: 10px;
  cursor: pointer;
  cursor: ${({ disabled }) => (disabled ? `not-allowed` : "pointer")};
`;

export const Menu = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: ${props => (props.isMobile ? "column" : "row")};
  border-bottom: 1px solid #e3e3e6;
  margin-bottom: 20px;
`;

export const ButtonMenu = styled.button<{ color?: string; selected?: boolean }>`
  background: none;
  border: none;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: ${props => (props.selected ? Colors.SPM600 : Colors.GRAY400)};
  border-bottom: ${props => (props.selected ? `2px solid ${Colors.SPM400}` : "none")};
  padding: 10px 20px;
  cursor: pointer;

  &:hover {
    color: ${Colors.SPM600};
  }
`;

export const Content = styled.div``;
